import React from "react";
import FilterAllCheckbox from "./FilterAllCheckbox";
import styles from "../FilterPanel.module.css";
import type { UpdateFilterFn, ToggleArrayFilterFn } from "../types";

type GenericFilterProps<T extends string> = {
  filterKey: string;
  selectedValues: T[];
  availableValues: T[];
  colorMap?: Record<string, string>;
  updateFilter: UpdateFilterFn;
  toggleArrayFilter: ToggleArrayFilterFn;
  isMobile: boolean;
  isActive: boolean;
  radioName?: string;
  renderLabel?: (value: T) => React.ReactNode;
  gridClassName?: string;
};

function GenericFilter<T extends string>({
  filterKey,
  selectedValues,
  availableValues,
  colorMap,
  updateFilter,
  toggleArrayFilter,
  isMobile,
  isActive,
  radioName,
  renderLabel,
  gridClassName = styles.cantonsGrid,
}: GenericFilterProps<T>) {
  const total = availableValues.length;
  const defaultRenderLabel = (value: T) => value;
  const labelRenderer = renderLabel || defaultRenderLabel;

  return (
    <div style={{ height: "100%" }}>
      <div className={styles.cantonsHeaderRow}>
        <FilterAllCheckbox
          selected={selectedValues}
          total={total}
          onToggle={(selectAll) => updateFilter(filterKey, selectAll ? availableValues : [])}
        />
        {isMobile && (
          <button
            type="button"
            className={styles.sectionReset}
            onClick={() => updateFilter(filterKey, [])}
          >
            Reset
          </button>
        )}
      </div>
      <div className={gridClassName}>
        {isActive
          ? availableValues.map((value) => {
              const color = colorMap?.[value] || "#999";
              return (
                <label key={value} className={`${styles.itemLabel} ${styles.itemLabelHover}`}>
                  <input
                    type="checkbox"
                    checked={selectedValues.includes(value)}
                    onChange={() => toggleArrayFilter(filterKey, value)}
                    className={`${styles.checkbox} ${styles.checkboxColored}`}
                    style={{ ["--checkbox-bg-color" as any]: color }}
                  />
                  {labelRenderer(value)}
                </label>
              );
            })
          : availableValues.map((value) => (
              <label key={value} className={`${styles.itemLabel} ${styles.itemLabelHover}`}>
                <input
                  type="radio"
                  name={radioName || `${filterKey}-radio`}
                  checked={selectedValues.length === 1 && selectedValues[0] === value}
                  onChange={() => updateFilter(filterKey, [value])}
                  className={styles.radio}
                />
                <span className={styles.labelText}>{labelRenderer(value)}</span>
              </label>
            ))}
      </div>
    </div>
  );
}

export default GenericFilter;
